export const cookies = {
  has_seen_intro: 'smk_open_has_seen_intro',
  cookies_accept: 'smk_open_cookies_accept',
  search_layout_id: 'smk_open_search_layout_id',
  my_list: 'smk_open_my_list',
  my_list_title: 'smk_open_my_list_title',
}
